// 获取浏览器参数
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
}
// 禁止浏览器缩放
// window.onload = function () {
function onload() {
  var lastTouchEnd = 0;
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener(
    "touchend",
    function (event) {
      var now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
  document.addEventListener("dblclick", function (event) {
    event.preventDefault();
  });
};

//图片懒加载处理 options为类名
function callback(entries) {
  for (let i = 0; i < entries.length; i++) {
    if (entries[i].isIntersecting) {
      let img = entries[i].target;
      let trueSrc = img.getAttribute("data-src");
      img.setAttribute("src", trueSrc);
      window.io.unobserve(img);
    }
  }
}

function lazyLoad(options) {
  window.io = new IntersectionObserver(callback);
  let imgAll = document.querySelectorAll(options);
  for (let i = 0; i < imgAll.length; i++) {
    window.io.observe(imgAll[i]);
  }
}



export default { getQueryVariable, onload, lazyLoad }
